<script setup>
import { CDN } from '@/__core__/cdn/cdn'
import { computed } from 'vue'

const props = defineProps({
  brand: String
})

const brandImageUrl = computed(() => `${CDN.getCdnUrl() === '/' ? 'http://127.0.0.1:3030' : CDN.getCdnUrl()}/brands/${props.brand}.png`)
</script>

<template>
  <div class="szw-flex szw-min-h-[38px] szw-h-[38px] szw-w-full szw-items-center szw-justify-center" style="border-bottom: 1px solid var(--szw-border)">
    <span>POWERED BY</span>
    <img height="22" :src="brandImageUrl" :alt="brand" />
  </div>
</template>
